export default __webpack_public_path__ + "879a04953cc76118f9de72e8a4ccae85.svg";